import { createMapFromOptions } from 'shared/lib';

import { OCCUPATION_OPTIONS_V2 } from './options';

/**
 * @description Occupation ID를 Label로 매핑하는 Map 객체
 * @example
 * occupationMap['UNDERGRADUATE'] // 'Undergraduate Student'
 * occupationMap['GRADUATE'] // 'Graduate Student'
 */
export const OCCUPATION_MAP = createMapFromOptions(OCCUPATION_OPTIONS_V2);
